import { onBeforeUnmount, type Ref, ref } from 'vue'

/**
 * useResize — composable replacing Vuetify's `v-resize` directive.
 * Uses the native ResizeObserver API to track element width/height.
 */
export function useResize(): {
  width: Ref<number>
  height: Ref<number>
  setTarget: (el: HTMLElement | null) => void
} {
  const width = ref(0)
  const height = ref(0)
  let observer: ResizeObserver | null = null
  let target: HTMLElement | null = null

  function setTarget(el: HTMLElement | null) {
    if (observer) {
      observer.disconnect()
      observer = null
    }
    target = el
    if (target) {
      const rect = target.getBoundingClientRect()
      width.value = rect.width
      height.value = rect.height
      observer = new ResizeObserver((entries) => {
        for (const entry of entries) {
          width.value = entry.contentRect.width
          height.value = entry.contentRect.height
        }
      })
      observer.observe(target)
    }
  }

  onBeforeUnmount(() => {
    if (observer) observer.disconnect()
  })

  return { width, height, setTarget }
}
